export default {
    // pdf预览
    pdfViewer: () => import( /* webpackChunkName: "yxPdfViewer" */ '../../views/YX/pdfViewer/index.vue')
}